import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "atropos/css";
import Home from "./Components/template/Home";
import CookieConsent from "./Components/ui/CookieConsent";
import { PrivacyPolicy, TermsOfService, BlogIndex, BlogPost } from "./routes";

/* SPA route changes keep the previous scroll position (users landed mid-page
 * on /blog after clicking the footer link) — reset to top on every pathname
 * change, like a normal page load. */
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      {/* No Suspense boundary: React hydrates one by looking for the
          `<!--$-->` comments it would have written, and the prerendered HTML
          is a browser snapshot that has none. src/routes.js loads chunks
          without it. */}
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/privacy' element={<PrivacyPolicy />} />
        <Route path='/terms' element={<TermsOfService />} />
        <Route path='/blog' element={<BlogIndex />} />
        <Route path='/blog/:slug' element={<BlogPost />} />
      </Routes>
      {/* Analytics is consent-gated (see the Consent Mode block in
          public/index.html); this bar is the only thing that grants it. */}
      <CookieConsent />
    </BrowserRouter>
  );
}

export default App;
